import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import NextArrowWithBorder from "images/white-arrow-right-with-border.png";

export const NextArrow = ({ onClick, className }) => {
    return (
        <button 
            onClick={onClick} 
            className={`z-10 cursor-pointer mr-2 w-8 h-8  ${className}`}
            aria-label="Next Image"
        >
            <img
                src={NextArrowWithBorder}
                alt="Next Arrow"
            />
        </button>
    );
};

export const PrevArrow = ({ onClick, className }) => {
    return (
        <button 
            onClick={onClick} 
            className={`z-10 cursor-pointer ml-2 w-8 h-8 rotate-180 ${className}`}
            aria-label="Next Image"
        >
            <img
                src={NextArrowWithBorder}
                alt="Next Arrow"
            />
        </button>
    );
};

export const Button = ({ onClick }) => (
    <button
        onClick={onClick} 
        className="btn btn-primary ml-auto !font-extralight mt-8 sm:mt-4"
    >
        View slide show
    </button>
);

export const defaultSettings = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: true,
};

export const ImageSwiper = ({ images, onOpenModal, eventIndex, modalState, className }) => {
    const [slideshow, setSlideshow] = useState(false);

    const handleModalSlideChange = () => {
        if (modalState?.currentEventIndex === undefined) return;

        if (eventIndex === modalState.currentEventIndex) slideshow?.slickGoTo(modalState.currentSlide);
    }

    useEffect(() => {
        handleModalSlideChange();
    }, [modalState.currentSlide]);

    if (!images || images.length === 0) return <div />;


    return (
        <>
            <Slider
                {...defaultSettings}
                ref={(slider1) => setSlideshow(slider1)}
                className={`images-gallery-modal relative ${className}`}
            >
                {images.map((image, index) => (
                    <img
                        key={index} 
                        src={image.src} 
                        alt={`Image - ${index}`} 
                        onClick={() => onOpenModal(eventIndex, index)}
                        className="hover:cursor-pointer"
                    />
                ))}
            </Slider>
        </>
    );
};

export const ModalContent = ({ images, setSlideshowSlider, initialSlide, settings }) => {
    if (!images || images.length === 0) return <div />;

    return (
        <>
            <Slider
                {...defaultSettings}
                {...settings}
                initialSlide={initialSlide}
                className="images-gallery-modal"
                ref={(slider1) => setSlideshowSlider(slider1)}
            >
                {images.map((image, index) => (
                    <img key={index} src={image.src} alt={`Image - ${index}`} />
                ))}
            </Slider>
        </>
    );
}